import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, SageTokens } from '@kajabi/sage-react';

import './style.scss';

const noop = () => {};

const withModal = (WrappedComponent) => {
  function Wrapper({ unmountReact, modalTitle, ...rest }) {
    return (
      <Modal
        active
        large
        className="sage-scoped"
        onExit={noop}
      >
        <Modal.Header
          title={modalTitle}
          aside={(
            <Button
              color={Button.COLORS.SECONDARY}
              iconPosition={Button.ICON_POSITIONS.RIGHT}
              icon={SageTokens.ICONS.REMOVE}
              subtle={true}
              onClick={unmountReact}
            >
              Close
            </Button>
          )}
        />
        <Modal.Body>
          <WrappedComponent {...rest} closeModal={unmountReact} />
        </Modal.Body>
      </Modal>
    );
  }

  Wrapper.propTypes = {
    unmountReact: PropTypes.func.isRequired,
    modalTitle: PropTypes.string
  };

  Wrapper.defaultProps = {
    modalTitle: 'Upload file'
  };

  return Wrapper;
};

export default withModal;
